import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface ConfidentialPictoProps extends pictoProps {
}

export interface ConfidentialPictoState extends pictoState {
}

export class ConfidentialPicto extends Picto<OfflinePictoProps,OfflinePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.confidentialBluePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(ConfidentialPicto);
